import { useEffect, useState } from "react"
import dayjs from 'dayjs'

const Table3 = ({ data, project }) => {
	const [tables, setTables] = useState()

    useEffect(() => {
		setTables(data.tables)
    }, [data])

    const formatNumber = (value) => {
        if (value == null) return ''
        const num = Number(value)
        if (Number.isNaN(num)) return value
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }

    return (
        <div className='py-5 px-2'>
            <div className='row d-flex justify-content-between'>
            {data && tables &&
                tables.map(table =>
                    <>
                        <h5 className='text-center w-100 mt-6 pt-6'>{table.project}</h5>
                        <table className='table table-bordered'>
                            <thead>
                                <tr style={{ verticalAlign: 'middle' }}>
                                    <th>Bina №</th>
                                    <th>Giriş №</th>
                                    <th>Mərtəbə</th>
                                    <th>Mənzil №</th>
                                    <th>Otaq sayı</th>
                                    <th>Ödəniş üsulu</th>
                                    <th>Satış qiyməti</th>
                                    <th>Mənzilə baxış keçirilməsinin başlama vaxtı</th>
                                    <th>Mənzil seçminin təsdiqləmə vaxtı</th>
                                    <th>İmzalanma vaxtı</th>
                                    <th>Mənzil seçimi ərizəsinin imzalanma vaxtı</th>
                                </tr>
                            </thead>
                            <tbody>
                                {table.rows.map(row =>
                                    <tr key={table.rows.indexOf(row)}>
                                        <td>{row.buildingNumber}</td>
                                        <td>{row.entranceNumber}</td>
                                        <td>{row.floorNumber}</td>
                                        <td>{row.apartmentNumber}</td>
                                        <td>{row.roomsCount}</td>
                                        <td>{row.paymentType === "Loan" ? "İpoteka krediti hesabına" : "Öz vəsaiti hesabına"}</td>
                                        <td>{formatNumber(row.price)} AZN</td>
                                        <td>{dayjs(row.previewOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        <td>{dayjs(row.confirmOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        <td>{dayjs(row.signatureOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        <td>{row.category}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </>)}
            </div>
        </div>
    )
}

export default Table3
